/**
 * User: n.gorte
 * Date: 18.09.2020
 * Time: 09:16
 */
import { EVENT_TYPE_CREATE, EVENT_TYPE_DELETE, EVENT_TYPE_UPDATE } from '../constants/Constants';

export const getEventType = (changeRecord) => {
    const { eventType, op } = changeRecord;
    const actionType = (eventType + op).toLowerCase();

    if (actionType.indexOf('post') > -1 || actionType.indexOf('create') > -1) {
        return EVENT_TYPE_CREATE;
    } else if (actionType.indexOf('delete') > -1) {
        return EVENT_TYPE_DELETE;
    } else {
        return EVENT_TYPE_UPDATE;
    }
};
    



// WEBPACK FOOTER //
// ./js/utils/event-type-util.js